import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/header/Header';
import Footer from "./components/footer/Footer";
import Home from "./pages/home/Home";
import Order from "./pages/order/Order";

function App() {
    return (
        <Router>
            <Header/>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Order" element={<Order/>}/>
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
